import ApiService from './apiService';

/**
 * Service pour gérer les régularisations de produits
 */
class ProductRegularizationService {
	/**
	 * Lister les régularisations avec filtres et pagination
	 * @param {Object} params Paramètres de filtrage/pagination (status, product_id, sale_id, pending_only, per_page, page, etc.)
	 * @returns {Promise}
	 */
	getRegularizations(params = {}) {
		return ApiService.get('/product-regularizations', params);
	}

	/**
	 * Lister uniquement les régularisations en attente
	 * @param {Object} params Paramètres supplémentaires (product_id, sale_id, per_page, page, etc.)
	 * @returns {Promise}
	 */
	getPendingRegularizations(params = {}) {
		return ApiService.get('/product-regularizations', {
			pending_only: true,
			...params
		});
	}

	/**
	 * Récupérer une régularisation par ID
	 * @param {number|string} id
	 * @param {Object} params Paramètres supplémentaires
	 * @returns {Promise}
	 */
	getRegularization(id, params = {}) {
		return ApiService.get(`/product-regularizations/${id}`, params);
	}

	/**
	 * Réconcilier une régularisation (réception du produit)
	 * @param {number|string} id
	 * @param {{notes?: string}} data
	 * @returns {Promise}
	 */
	reconcileRegularization(id, { notes = '' }) {
		return ApiService.post(`/product-regularizations/${id}/reconcile`, {
			notes
		});
	}

	/**
	 * Annuler une régularisation
	 * @param {number|string} id
	 * @returns {Promise}
	 */
	cancelRegularization(id) {
		return ApiService.post(`/product-regularizations/${id}/cancel`);
	}
}

export default new ProductRegularizationService();


